import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrudModel {

  public valueChecked = new Subject<any>();
  public arrayFilter = [];
  public dataSource: any;
  public receivedData: any;
  public table: any;
  public paginator: any;
  public sort: any;
  public sorts = [];
  public arraySource = [];
  public selection: any;
  public rowChanged: any;
  public eventCheck: any;
  public statusFilter = false;

  constructor() { }

  public rowsCrud(dataSource, receivedData, table, paginator, sort) {
    this.dataSource = dataSource;
    this.receivedData = receivedData;
    this.table = table;
    this.paginator = paginator;
    this.sort = sort;
    this.refreshTable();
    if (dataSource.data.length > 0) {
      this.getDataSource(dataSource);
    } else {
      this.getDataSource(dataSource);
    }
  }

  private getDataSource(d) {
    this.arraySource.push(d);
  }

  /**
   *  Função para adicionar linhas quando tiver mais de um crud em uma mesma pagina
   * @param ide identificação do crud
   * @param rowObj array com os dados para adicionar no crud
   */
  public addRowDataSpecific(ide: string, rowObj: Array<any>) {
    const table = this.refreshMatSort(this.sorts, ide);

    if (typeof table.dataSource.data !== 'undefined') {
      const array = table.dataSource.data;
      Array.prototype.push.apply(array, rowObj);
      table.renderRows();
      this.refreshTable();
      table.dataSource.sort = table.dataSource.sort;
    } else if (typeof table.dataSource.data === 'undefined') {
      const array = table.dataSource;
      Array.prototype.push.apply(array, rowObj);
      table.renderRows();
      this.refreshTable();
      table.dataSource.sort = this.sort;
    } else if (typeof table.dataSource.data === 'undefined') {
      const array = table.dataSource;
      array.push(rowObj);
      table.renderRows();
      this.refreshTable();
      table.dataSource.sort = this.sort;
    } else {
      table.dataSource.data.push(rowObj);
      table.renderRows();
      this.refreshTable();
      table.dataSource.sort = table.dataSource.sort;
    }
  }

  /**
   *  Função para adicionar linhas no crud
   * @param rowObj array com os dados para adicionar no crud
   */
  public addRowData(rowObj: Array<any>) {
    if (Array.isArray(rowObj) && typeof this.dataSource.data !== 'undefined') {
      const array = this.dataSource.data;
      Array.prototype.push.apply(array, rowObj);
      this.table.renderRows();
      this.refreshTable();
      this.paginator.length = array.length;
      this.dataSource.sort = this.sort;
    } else if (Array.isArray(rowObj) && typeof this.dataSource.data === 'undefined') {
      const array = this.dataSource;
      Array.prototype.push.apply(array, rowObj);
      this.table.renderRows();
      this.refreshTable();
      this.paginator.length = array.length;
      this.dataSource.sort = this.sort;
    } else if (typeof this.dataSource.data === 'undefined') {
      const array = this.dataSource;
      array.push(rowObj);
      this.table.renderRows();
      this.refreshTable();
      this.paginator.length = array.length;
      this.dataSource.sort = this.sort;
    } else {
      const array = this.dataSource.data;
      array.push(rowObj);
      this.table.renderRows();
      this.refreshTable();
      this.paginator.length = array.length;
      this.dataSource.sort = this.sort;
    }
  }

  /**
   * Função para atualizar o dados da linha quando tiver mais de um crud em uma mesma pagina
   * @param ide identificação do crud
   * @param rowObj objeto com os dados para atualizar no crud
   */
  public updateRowDataSpecific(ide: string, rowObj) {
    const table = this.refreshMatSort(this.sorts, ide);
    table.dataSource.data = table.dataSource.data.filter((value, key) => {
      if (value.id === rowObj.id) {
        // tslint:disable-next-line: forin
        for (const index in rowObj) {
          value[index] = rowObj[index];
        }
      }
      return true;
    });
    table.renderRows();
    table.dataSource.sort = table.dataSource.sort;
  }

  /**
   * Função para atualizar os dados da linha do crud
   * @param ide identificação do crud
   * @param rowObj objeto com os dados para atualizar no crud
   */
  public updateRowData(rowObj) {
    this.dataSource.data = this.dataSource.data.filter((value, key) => {
      if (value.id === rowObj.id) {
        // tslint:disable-next-line: forin
        for (const index in rowObj) {
          value[index] = rowObj[index];
        }
      }
      return true;
    });
    this.table.renderRows();
    this.dataSource.sort = this.sort;
  }

  /**
   * Função para excluir a linha quando tiver mais de um crud na mesma pagina
   * @param ide identificação do crud
   * @param rowObj id do objeto para exclusão
   */
  public deleteRowDataSpecific(ide: string, rowObj) {
    const table = this.refreshMatSort(this.sorts, ide);
    if (typeof table.dataSource.data === 'undefined') {
      const array = this.receivedData;
      const result = this.arrayRemove(array, Number(rowObj));
      this.receivedData = result;
      table.renderRows();
      table.dataSource.sort = table.dataSource.sort;
    } else {
      const array = table.dataSource.data;
      const result = this.arrayRemove(array, Number(rowObj));
      table.dataSource.data = result;
      table.renderRows();
      table.dataSource.sort = table.dataSource.sort;
    }
  }

  /**
   * Função para excluir a linha do crud
   * @param rowObj id do objeto para exclusão
   */
  public deleteRowData(rowObj) {
    if (typeof this.dataSource.data === 'undefined') {
      const array = this.receivedData;
      const result = this.arrayRemove(array, Number(rowObj));
      this.receivedData = result;
      this.table.renderRows();
      this.paginator.length = result.length;
      this.dataSource.sort = this.sort;
    } else {
      const array = this.dataSource.data;
      const result = this.arrayRemove(array, Number(rowObj));
      this.dataSource.data = result;
      this.table.renderRows();
      this.paginator.length = result.length;
      this.dataSource.sort = this.sort;
    }
  }

  /**
   * Função que pega os dados quando altera as linhas do crud
   * @param obj array de dados do crud
   */
  public rowChange(obj) {
    this.rowChanged = obj;
    return obj;
  }

  public getMatSort(obj) {
    this.sorts.push(obj);
  }

  public refreshTable() {
    this.paginator._changePageSize(this.paginator.pageSize);
  }

  public refreshMatSort(sort, ide) {
    // tslint:disable-next-line: forin
    for (const source in this.arraySource) {
      if (sort[source].first._elementRef.nativeElement.id === ide) {
        return sort[source].first;

      }
    }
  }

  private arrayRemove(arr, value) {
    return arr.filter((ele) => {
      return ele.id !== value;
    });
  }

  public setRowChecked(params) {
    this.valueChecked.next(params);
  }


  public getRowCheck(): Observable<any> {
    return this.valueChecked.asObservable();
  }


  public getSelection(selection) {
    this.selection = selection;
    return selection;
  }

  public isAllSelected(dataSource) {
    const numSelected = this.selection.selected.length;
    const numRows = dataSource.data.length;
    return numSelected === numRows;
  }

  /**
   * Função para obter as linhas selecionadas do crud
   * @param $event evento de check
   * @param dataRow objeto das linhas
   * @param array array de objetos selecionados
   * @param dataSource data source do crud, usando o parentScope
   */
  public getRowChecked($event, dataRow, array, dataSource, t = null) {
    this.eventCheck = $event;
    if (this.isAllSelected(t)) {
      array = t.filteredData;
    } else if ($event.checked) {
      if (Array.isArray(dataRow)) {
        if (array.length === 0) {
          array = dataRow;
        } else {
          array.concat(dataRow);
        }
      } else {
        array.push(dataRow);
      }
    } else if ($event.checked === false && typeof dataRow !== 'undefined') {
      if (Array.isArray(dataRow)) {
        array = array.filter(item => !dataRow.includes(item));
      } else if (Array.isArray(array)) {
        array = array.filter(item => item !== dataRow);
      } else {
        array = [array];
      }
    } else {
      array = [];
    }
    setTimeout(() => {
      this.setRowChecked(array);
    });
    return array;
  }

  public getRowChecked2() {
    this.selection.clear();
    this.table.renderRows();
  }

  public buildFilter(dados) {
    return this.arrayFilter = dados;
  }

  public setStatusFilter(status) {
    this.statusFilter = status;
  }

}
